module.exports = __webpack_public_path__ + "img/fdkj.2ebb357d.png";